import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DeploymentDetail from "./pages/DeploymentDetail";
import NewDeployment from "./pages/NewDeployment";
import Survey from "./pages/Survey";
import RespondentReport from "./pages/RespondentReport";
import OrgTrends from "./pages/OrgTrends";
import AdminCleanup from "./pages/AdminCleanup";
import SuppressionBypassAudit from "./pages/SuppressionBypassAudit";
import AdminCoachingReports from "./pages/AdminCoachingReports";
import TelemetrySummary from "./pages/TelemetrySummary";
import VersionFooter from "./components/VersionFooter";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-paper">
        <div className="eyebrow text-gray-500">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        {/* Keyboard skip-to-content link — visually hidden until focused. */}
        <a href="#main-content" className="skip-link" data-testid="skip-link">
          Skip to main content
        </a>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/dashboard/deployments/new" element={<Protected><NewDeployment /></Protected>} />
          <Route path="/dashboard/deployments/:id" element={<Protected><DeploymentDetail /></Protected>} />
          <Route path="/dashboard/orgs/:orgId/trends" element={<Protected><OrgTrends /></Protected>} />
          <Route path="/dashboard/admin/cleanup" element={<Protected><AdminCleanup /></Protected>} />
          <Route path="/dashboard/admin/audit/suppression-bypass" element={<Protected><SuppressionBypassAudit /></Protected>} />
          <Route path="/dashboard/admin/coaching-reports" element={<Protected><AdminCoachingReports /></Protected>} />
          <Route path="/dashboard/admin/telemetry/nudge-dot-90day" element={<Protected><TelemetrySummary /></Protected>} />
          <Route path="/survey/:token" element={<Survey />} />
          <Route path="/respondent-report/:token" element={<RespondentReport />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <VersionFooter />
      </BrowserRouter>
    </AuthProvider>
  );
}
